var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"map",style:(_vm.cstyle)}),(_vm.map)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }